/* src/app/components/session-info/reservation-text/reservation-text.component.scss */
/*# sourceMappingURL=reservation-text.component.css.map */
